module.exports = __webpack_public_path__ + "static/cubesobjects-5074b0b327e3cb1bc2e5ba6c4c25200d.mp4";